import { ILoginSession } from 'types/session';
import { LOGIN_TYPE } from 'modules/login/login.constants';

export const loginSessionMock: ILoginSession = {
    type: LOGIN_TYPE.NEW_LOGIN,
    sessionId: '740ab387-b4a5-45fd-bfae-bd61b8dbccdc',
    isUbisoftConnectAuthenticated: true,
    UbisoftConnectProfile: {
        op: 'getProfiles',
        status: 'OK',
        ref: '12f7f27b-e4ef-4a29-9fe3-a9712d0db247_530',
        user: {
            profileId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            platformType: 'uplay',
            idOnPlatform: '9D7DAB4D-0403-4838-9AED-10B9B77591B5',
            nameOnPlatform: 'ulgui-ubi4'
        }
    },
    UbisoftConnectProfiles: [
        {
            profileId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            platformType: 'uplay',
            idOnPlatform: '9D7DAB4D-0403-4838-9AED-10B9B77591B5',
            nameOnPlatform: 'ulgui-ubi4'
        },
        {
            profileId: '2b204df2-75e3-400b-bbd4-0ba28c8eae77',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            platformType: 'psn',
            idOnPlatform: '6808430300154271139',
            nameOnPlatform: 'qwerty12345qaz'
        },
        {
            profileId: 'ba6f9c51-3a7d-4d59-9a8a-259d8f336048',
            userId: '9d7dab4d-0403-4838-9aed-10b9b77591b5',
            platformType: 'twitch',
            idOnPlatform: '145698663',
            nameOnPlatform: 'ubitestaccount2'
        },
        {
            profileId: '-----',
            userId: '-----',
            platformType: 'wrongPlatform',
            idOnPlatform: '145698663',
            nameOnPlatform: '-----'
        }
    ],
    UbisoftConnectTicket: 'ew0KICAidmVyIjogIjEiLA0KICAiYWlkIjogIjEyZjdmMjdiLWU0ZWYtNGEyOS05ZmUzLWE5NzEyZDBkYjI0NyIsDQogICJlbnYiOiAiVUFUI'
};

export const rawUbisoftConnectProfilesMock = {
    op: 'getProfiles',
    status: 'OK',
    ref: '12******-e***-****-****-************_***',
    user: {
        profiles: [
            {
                profileId: '********-****-****-****-************',
                userId: '********-****-****-****-************',
                platformType: 'uplay',
                idOnPlatform: '********-****-****-****-************',
                nameOnPlatform: 'd*******'
            }
        ]
    }
};

export const userTicketMock = loginSessionMock.UbisoftConnectTicket;
